import isNumber from 'lodash/isNumber'

import type { VatRate } from '../types/vatRate'
import { findVatRateById } from './findVatRateById'

// Several FR rates share 0% - without the original rate id we can't tell which exemption
// applied, so prefer the generic 0% over whichever specific one has the highest priority.
const preferredVatRateId = 's_fr_0'

export const findVatRateByPercent = (vatRates: VatRate[], percent?: number): VatRate | undefined => {
  if (!isNumber(percent)) {
    return undefined
  }
  const matchingVatRates = vatRates.filter((vatRate) => vatRate.rate === percent)

  return findVatRateById(matchingVatRates, preferredVatRateId) ?? matchingVatRates[0]
}
